import React from "react";

export default function WinRateDonut({ value = 0, label, tp = 0, sl = 0, closed = 0, pfs, pfr, color = "#10B981", testid, size = 132, onClick }) {
  // Profit Factor mostrato = media tra PF Signal e PF Real
  const hasPF = pfs !== undefined || pfr !== undefined;
  const parts = [pfs, pfr].filter((v) => v != null);
  let pfAvg = null; // null = nessun dato
  let pfInf = false;
  if (parts.length) {
    if (parts.some((v) => v >= 999)) pfInf = true;
    else pfAvg = Math.round((parts.reduce((a, b) => a + b, 0) / parts.length) * 100) / 100;
  }
  const pfText = pfInf ? "∞" : pfAvg == null ? "—" : pfAvg;
  const pfOk = pfInf || (pfAvg != null && pfAvg >= 1);
  const stroke = Math.round(size / 11);
  const r = (size - stroke) / 2;
  const circumference = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value || 0));
  const offset = circumference * (1 - pct / 100);
  const clickable = typeof onClick === "function";

  return (
    <div
      data-testid={testid}
      onClick={onClick}
      role={clickable ? "button" : undefined}
      className={`bg-[#141414] border border-white/10 rounded-md p-5 flex flex-col items-center transition-all ${
        clickable ? "cursor-pointer hover:border-white/30 hover:bg-[#181818]" : ""
      }`}
    >
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth={stroke} />
          <circle
            cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
            strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={offset}
            style={{ transition: "stroke-dashoffset 0.8s ease" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="font-mono text-2xl font-semibold text-white">{pct}%</span>
          <span className="text-[10px] text-zinc-500 uppercase tracking-wider">Win rate</span>
        </div>
      </div>
      <div className="text-sm font-medium text-white mt-3 text-center">{label}</div>
      <div className="flex items-center gap-3 mt-1.5 text-xs font-mono">
        <span className="text-emerald-400">TP {tp}</span>
        <span className="text-zinc-600">·</span>
        <span className="text-red-400">SL {sl}</span>
        <span className="text-zinc-600">·</span>
        <span className="text-zinc-400">{closed} chiusi</span>
      </div>
      {hasPF && (
        <div data-testid={testid ? `${testid}-pfr` : undefined}
          className={`mt-2 text-xs font-mono px-2.5 py-1 rounded-full border ${
            pfAvg == null && !pfInf ? "text-zinc-500 border-white/10"
              : pfOk ? "text-emerald-400 border-emerald-500/30 bg-emerald-500/10"
              : "text-red-400 border-red-500/30 bg-red-500/10"}`}>
          PROFIT FACTOR: {pfText}
        </div>
      )}
      {clickable && (
        <div className="text-[11px] text-zinc-500 mt-2 group-hover:text-zinc-300">Tocca per i dettagli →</div>
      )}
    </div>
  );
}
